export { default } from './svg/linkedin.svg';
